import script from "./Introduction.vue?vue&type=script&setup=true&lang=ts"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=ts"

import "./Introduction.vue?vue&type=style&index=0&id=2bdca2ca&lang=scss"

const __exports__ = script;

export default __exports__